import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from '../actions/MenuAction';
class ItemDetailNewStore extends EventEmitter {
    TabOneRespList = "";
    addToCartList = "";
    TabClickList = "";
    FavitemAddList = "";
    //[2/28/22], PC_IC_05, WW-316, Dhevanesam R
    GetRecommendedItems = "";
    attachmentResponse = "";
    EditImageSubmission = "";
    handleItemDetailNewStore = (action) => {
        switch (action.action.type) {
            case "TabOneResp": {
                this.TabOneRespList = action.action.response;
                this.emit('TabOneResp');
                break;
            }
            /*[04/18/22,PC_WW-386_06], Priyanka D */
            case "EditImgResponse": {
                this.attachmentResponse = action.action.response;
                this.emit('EditResponse');
                break;
            }
            case "NONCAT_UploadAttachments": {
                this.attachmentResponse = action.action.response;
                this.emit('NONCAT_UploadAttachments');
                break;
            }
            case "EditImgSubmit": {
                this.EditImageSubmission = action.action.response;
                this.emit('EditImgSubmit');
                break;
            }
            case "addToCart": {
                /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                MenuAction.refreshCartCount();
                this.addToCartList = action.action.response;
                this.emit('addToCart');
                break;
            }
            case "TabClick": {
                this.TabClickList = action.action.response;
                this.emit('TabClick');
                break;
            }
            case "FavitemAdd": {
                this.FavitemAddList = action.action.response;
                this.emit('FavitemAdd');
                break;
            }
            case SDIConstants.methodNames.FavItemMaintenance_DeleteFavItem: {
                this.DeleteDet = action.action.response;
                this.emit('DeleteItem');
                break;
            }
            /**
             *CIPS_PS_01
             * */
            case "CheaperItem": {
                this.FavitemAddList = action.action.response;
                this.emit('CheaperItem');
                break;
            }
            //[2/28/22], PC_IC_05, WW-316, Dhevanesam R
            case "GetRecommendedItems": {
                this.GetRecommendedItems = action.action.response;
                this.emit('GetRecommendedItems');
                break;
            }
            case "RatingSubmissionresponse": {
                this.RatingSubmissionresponse = action.action.response;
                this.emit('RatingResponse');
                break;
            }


            case "ItemDetail_ByPass": {
                /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                MenuAction.refreshCartCount();
                this.ItemDetail_ByPass = action.action.response;
                this.emit('ItemDetail_ByPass');
                break;
            }

            case "ItemDetail_DynamicForm": {
                this.ItemDetail_DynamicForm = action.action.response;
                this.emit('ItemDetail_DynamicForm');
                break;
            }
        }
    }
}


const objItemDetailNewStore = new ItemDetailNewStore;
Dispatcher.register(objItemDetailNewStore.handleItemDetailNewStore.bind(objItemDetailNewStore));
export default objItemDetailNewStore;
